import React, {FC} from "react";
import {OrderEventType} from "data/types";
import OrderCard from "./OrderCard";

export interface OrderEventCardProps {
  className?: string;
  size?: "default" | "small";
  order: OrderEventType | any;
  isSubscriber?: boolean;
  isRaffle: boolean;
  subscriberImg?: string;
  isPastEvent?: boolean;
}

const OrderEventCard: FC<OrderEventCardProps> = ({
  size = "default",
  className = "",
  order,
  isSubscriber = false,
  isRaffle,
  subscriberImg,
  isPastEvent = false,
}) => {
  const {event} = order;

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        <OrderCard
          id={order._id}
          name={
            isSubscriber ? order.subscriberList.timeName.name : event.nameEvent
          }
          count={isSubscriber ? order.numberSeat : order.tickets}
          thumbnail={isSubscriber ? order.event.img : event.img}
          isSubscriber={isSubscriber}
          isRaffle={isRaffle}
          type={order.type}
          order={order}
          subscriberImg={subscriberImg}
          isPastEvent={isPastEvent}
        />
        {!isSubscriber && (
          <div
            className={`nc-SaleOffBadge
            absolute left-3 top-3
            flex items-center justify-center
            text-xs font-semibold
            py-0.5 px-3
            border border-black/40
            bg-black/40
            text-white
            rounded-full
            backdrop-blur-3xl
          `}
          >
            {order.type}
          </div>
        )}

        {/* <BtnLikeIcon isLiked={true} className="absolute right-3 top-3 z-[1]" />
        {true && (
          <SaleOffBadge className="absolute left-3 top-3" desc={order.type} />
        )} */}
      </div>
    );
  };

  return renderSliderGallery();
};

export default OrderEventCard;
